import {$,$$} from '../core/dom.js';
import {readJSON,writeJSON,STORAGE_KEYS} from '../core/storage.js';

const categories=['later','maybe','important'];
const labels={later:'Later',maybe:'Maybe',important:'Important'};
const pageSize=24;

function nowISO(){return new Date().toISOString()}
function makeId(){return crypto.randomUUID()}
function normalizeCategory(value){return categories.includes(value)?value:'later'}
function isValidDate(value){return typeof value==='string'&&!Number.isNaN(Date.parse(value))}

function normalizeItems(value){
  const list=Array.isArray(value)?value:value?.items;
  if(!Array.isArray(list))return [];
  const seen=new Set();
  return list.flatMap(item=>{
    if(!item||typeof item!=='object'||Array.isArray(item))return [];
    const text=String(item.text||'').trim();
    if(!text)return [];
    const id=typeof item.id==='string'&&item.id.trim()?item.id.trim():makeId();
    if(seen.has(id))return [];
    seen.add(id);
    const createdAt=isValidDate(item.createdAt)?item.createdAt:'1970-01-01T00:00:00.000Z';
    const updatedAt=isValidDate(item.updatedAt)?item.updatedAt:createdAt;
    return [{id,text,category:normalizeCategory(item.category),createdAt,updatedAt}];
  });
}

function formatWhen(value){
  const date=new Date(value);
  if(Number.isNaN(date.getTime())||date.getTime()===0)return 'Saved for later';
  const today=new Date();
  const sameDay=date.toDateString()===today.toDateString();
  if(sameDay)return date.toLocaleTimeString(undefined,{hour:'numeric',minute:'2-digit'});
  return date.toLocaleDateString(undefined,{month:'short',day:'numeric'});
}

export function initParkingLot({motion,navigation,sound}){
  const state={items:normalizeItems(readJSON(STORAGE_KEYS.PARKING_LOT,[])),selected:null,visibleLimit:pageSize,deleteArmed:null,deleteTimer:null,feedbackTimer:null};
  const input=$('#parkingInput'),charCount=$('#parkingCharCount'),validation=$('#parkingValidation'),feedback=$('#parkingFeedback'),list=$('#parkingList'),empty=$('#parkingEmpty'),total=$('#parkingTotal'),showOlder=$('#parkingShowOlder'),submit=$('#parkItBtn'),capture=$('.parking-capture'),listPanel=$('.parking-list-panel');

  function persist(){return writeJSON(STORAGE_KEYS.PARKING_LOT,state.items)}
  function setFeedback(message){
    feedback.textContent=message;feedback.classList.toggle('show',Boolean(message));clearTimeout(state.feedbackTimer);
    if(message)state.feedbackTimer=setTimeout(()=>feedback.classList.remove('show'),3200);
  }
  function setValidation(message=''){validation.textContent=message}
  function updateCount(){charCount.textContent=String(input.value.length)}
  function setSelected(category){
    state.selected=category;
    $$('[data-parking-category]').forEach(button=>{const active=button.dataset.parkingCategory===category;button.classList.toggle('selected',active);button.setAttribute('aria-pressed',String(active))});
  }
  function clearDeleteArm(){
    clearTimeout(state.deleteTimer);state.deleteTimer=null;state.deleteArmed=null;
    $$('.parking-delete').forEach(button=>{button.textContent='Delete';button.classList.remove('confirm');button.setAttribute('aria-label','Delete parked idea')});
  }
  function renderCategoryChip(category){
    const pill=document.createElement('span');pill.className=`parking-pill pill-${category}`;pill.textContent=labels[category];return pill;
  }
  function renderEmpty(){
    const hasItems=state.items.length>0;empty.hidden=hasItems;list.hidden=!hasItems;showOlder.hidden=state.items.length<=state.visibleLimit;
  }
  function render(){
    clearDeleteArm();total.textContent=String(state.items.length);list.replaceChildren();
    for(const item of state.items.slice(0,state.visibleLimit))list.appendChild(renderItem(item));
    renderEmpty();
  }
  function renderItem(item){
    const card=document.createElement('article');card.className='parking-item';card.dataset.parkingId=item.id;
    const top=document.createElement('div');top.className='parking-item-top';
    const meta=document.createElement('div');meta.className='parking-meta';meta.append(renderCategoryChip(item.category));
    const when=document.createElement('span');when.className='parking-when';when.textContent=formatWhen(item.updatedAt);meta.appendChild(when);
    const actions=document.createElement('div');actions.className='parking-actions';
    const edit=document.createElement('button');edit.type='button';edit.className='parking-action parking-edit';edit.textContent='Edit';edit.setAttribute('aria-label','Edit parked idea');
    const del=document.createElement('button');del.type='button';del.className='parking-action parking-delete';del.textContent='Delete';del.setAttribute('aria-label','Delete parked idea');
    actions.append(edit,del);top.append(meta,actions);
    const text=document.createElement('p');text.className='parking-text';text.textContent=item.text;
    card.append(top,text);
    edit.addEventListener('click',()=>renderEditor(card,item));
    del.addEventListener('click',()=>deleteItem(item.id,del));
    return card;
  }
  function renderEditor(card,item){
    clearDeleteArm();card.classList.add('editing');card.replaceChildren();
    const label=document.createElement('label');label.className='parking-edit-label';label.textContent='Edit parked idea';
    const editInput=document.createElement('textarea');editInput.className='parking-edit-input';editInput.maxLength=360;editInput.rows=4;editInput.value=item.text;
    const chipRow=document.createElement('div');chipRow.className='parking-edit-chips';let category=item.category;
    for(const name of categories){
      const chip=document.createElement('button');chip.type='button';chip.className=`parking-chip chip-${name}`;chip.textContent=labels[name];chip.dataset.editCategory=name;chip.setAttribute('aria-pressed',String(name===category));chip.classList.toggle('selected',name===category);
      chip.addEventListener('click',()=>{category=name;$$('[data-edit-category]',chipRow).forEach(button=>{const active=button.dataset.editCategory===name;button.classList.toggle('selected',active);button.setAttribute('aria-pressed',String(active))})});
      chipRow.appendChild(chip);
    }
    const actions=document.createElement('div');actions.className='parking-edit-actions';
    const save=document.createElement('button');save.type='button';save.className='parking-save';save.textContent='Save';
    const cancel=document.createElement('button');cancel.type='button';cancel.className='parking-cancel';cancel.textContent='Cancel';
    actions.append(save,cancel);card.append(label,editInput,chipRow,actions);
    cancel.addEventListener('click',render);
    save.addEventListener('click',()=>{
      const text=editInput.value.trim();
      if(!text){setFeedback('Give the shiny thing a few words first.');editInput.focus();return}
      const previous=state.items;
      state.items=state.items.map(existing=>existing.id===item.id?{...existing,text,category,updatedAt:nowISO()}:existing);
      if(!persist()){state.items=previous;setFeedback('Could not save. Your changes are still in this field.');return}render();setFeedback('Saved for later. ♡');sound.playSave();
    });
    editInput.focus({preventScroll:true});
  }
  function deleteItem(id,button){
    if(state.deleteArmed!==id){
      clearDeleteArm();state.deleteArmed=id;button.textContent='Delete?';button.classList.add('confirm');button.setAttribute('aria-label','Confirm delete parked idea');
      state.deleteTimer=setTimeout(clearDeleteArm,2400);return;
    }
    const previous=state.items;state.items=state.items.filter(item=>item.id!==id);if(!persist()){state.items=previous;setFeedback('Could not save the change. Your idea is still here.');return}render();setFeedback('Cleared from the parking lot.');sound.playSave();
  }
  async function animateParkedSlip(text,category){
    if(motion.isReduced()||!capture||!listPanel||!document.body.animate)return;
    const from=input.getBoundingClientRect(),to=listPanel.getBoundingClientRect(),slip=document.createElement('div');
    slip.className=`parking-slip-flight slip-${category}`;slip.textContent=text.slice(0,64);document.body.appendChild(slip);
    const width=Math.min(270,Math.max(180,from.width*.74));
    Object.assign(slip.style,{position:'fixed',left:`${from.left+from.width*.13}px`,top:`${from.top+from.height*.56}px`,width:`${width}px`});
    const start=slip.getBoundingClientRect(),endX=to.left+Math.min(to.width*.14,46)-start.left,endY=to.top+96-start.top;
    const animation=slip.animate([
      {transform:'translate3d(0,0,0) rotate(-1deg) scale(.98)',opacity:.92,offset:0,easing:'cubic-bezier(.22,.72,.25,1)'},
      {transform:`translate3d(${endX*.35}px,${endY*.35-16}px,0) rotate(2deg) scale(1.02)`,opacity:1,offset:.48,easing:'cubic-bezier(.28,.78,.32,1)'},
      {transform:`translate3d(${endX}px,${endY}px,0) rotate(-.5deg) scale(.96)`,opacity:.04,offset:1}
    ],{duration:460,easing:'linear',fill:'forwards'});
    try{await animation.finished}catch{}
    slip.remove();
  }
  async function parkIt(){
    const text=input.value.trim();
    if(!text){setValidation('Give the shiny thing a few words first.');setFeedback('');input.focus();return}
    setValidation('');submit.disabled=true;void sound.unlock();
    const item=addIdea(text,state.selected,{renderNow:false});
    if(!item){setFeedback('This browser could not save it. Your idea is still here.');submit.disabled=false;return}
    input.value='';updateCount();setSelected(null);
    await animateParkedSlip(text,item.category);
    state.visibleLimit=Math.max(pageSize,state.visibleLimit);render();setFeedback('You don’t have to act on it now. ♡');sound.playPark();submit.disabled=false;input.focus({preventScroll:true});
  }
  input.addEventListener('input',()=>{updateCount();if(input.value.trim())setValidation('')});
  submit.addEventListener('click',parkIt);
  $$('[data-parking-category]').forEach(button=>button.addEventListener('click',()=>setSelected(state.selected===button.dataset.parkingCategory?null:button.dataset.parkingCategory)));
  showOlder.addEventListener('click',()=>{state.visibleLimit+=pageSize;render()});
  navigation.onShow(name=>{if(name==='parking'){state.items=normalizeItems(readJSON(STORAGE_KEYS.PARKING_LOT,[]));state.visibleLimit=pageSize;render();updateCount();setValidation('')}});
  updateCount();setSelected(null);render();
  // Integration entry point: use the same schema, persistence and renderer as this tool.
  // Capture and external tools share one insertion path; edit/delete are unchanged.
  function addIdea(text,category='later',{renderNow=true}={}){
    const clean=String(text||'').trim();if(!clean)return null;
    const timestamp=nowISO(),item={id:makeId(),text:clean,category:normalizeCategory(category),createdAt:timestamp,updatedAt:timestamp};
    const previous=normalizeItems(readJSON(STORAGE_KEYS.PARKING_LOT,[]));
    state.items=[item,...previous];
    if(!persist()){state.items=previous;return null}
    if(renderNow)render();return item;
  }
  return {parkIt,addIdea,getState:()=>({items:[...state.items],selected:state.selected})};
}
